import {Component} from '@angular/core';
import {UserFileCRUDComponent} from '../components/user-file-crud/user-file-crud.component';
import {PrimeNgImportsModule} from '../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../sdk/src/components/ibase-page/ibase-page.component';

@Component({
    selector: 'app-customer-files-page',
    templateUrl: './customer-files-page.component.html',
    imports: [PrimeNgImportsModule, UserFileCRUDComponent]
})
export class CustomerFilesPageComponent extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    protected override async onReady(): Promise<void> {
        await this.globalsService.sessionService.getRouteContextIsReadyPromise();
    }
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
